import React, { useState } from 'react';
import { connect } from 'react-redux';

import { changeUpcomingPublicationListFilter } from '../upcomingPublication.actions';
import { getUpcomingPublicationAvailableFilters } from '../upcomingPublication.selectors';

import {FilterItemDatePicker} from '../../common/sponsorships/filters/filterItemComponent';
import Filter from '../../common/sponsorships/filters/filter';
import { getDefaultRequestBuilder } from '../../common/sponsorships/filters/filterHelper';
import { getDefaultSelectedMonths } from '../../common/sponsorships/filters/dateFilterHelper';
import filterIds from '../../common/sponsorships/filters/filter_ids';
import { useAuth0, getSelectedTenantId } from '../../app/auth';

const UpcomingPublicationListFiltersComponent = (props) => {
  
  const [builder] = useState(getDefaultRequestBuilder(true));
  const { getTokenSilently, user } = useAuth0();

  const addFilterParam = (filterId, itemId) => {
    builder.addParam(filterId, itemId);
    notifyFilterChanged();
    
  };

  const removeFilterParam = (filterId, itemId, silently=false) => {
    builder.removeParam(filterId, itemId);
    if (!silently) notifyFilterChanged();
  };

  const handleFilterSelection = (filterId, itemId, selected) => {
    if(selected) {
      addFilterParam(filterId, itemId);
    } else {
      removeFilterParam(filterId, itemId);
    }
  };

  const notifyFilterChanged = async() => {
    const token = await getTokenSilently();
    const queryString = builder.getQueryString();
    props.onFilterChanged(queryString, token, getSelectedTenantId(user, token));
  };

  const createCustomDatePicker = () => {
    return (
      <FilterItemDatePicker addFilterParam={addFilterParam} removeFilterParam={removeFilterParam} />
    );
  };

  const { months, priceBuckets, typeOfContract } = props;

  const filterConfig = [
    { id: filterIds.DATE, title: 'Period', options: months, selectedOptions: getDefaultSelectedMonths(true), allOption: false, renderCustomFilter: createCustomDatePicker},
    { id: filterIds.PRICE, title: 'Price', options: priceBuckets, allOption: false },
    { id: filterIds.IS_PBD, title: 'Type of Contract', options: typeOfContract, allOption: false}
  ];

  const filters = filterConfig.map(config => (
      <Filter key={config.id} filterId={config.id} filterSelectionChanged={handleFilterSelection} filterType = {config.filterType} {...config} />
  ));

  return (
    <div>
      {filters}
    </div>
  );
};

function mapStateToProps(state) {
  const filters = getUpcomingPublicationAvailableFilters(state) || {};

  let publicationStatuses = [];
  let priceBuckets = [];
  let months = [];
  let budgets = [];
  let typeOfContract = [];

  if(filters && Object.keys(filters).length > 0) {
    publicationStatuses = filters.publicationStatuses;
    priceBuckets = filters.priceBuckets;
    months = filters.months;
    budgets =  filters.budgets;
    typeOfContract = filters.typeOfContract;
  }

  return { publicationStatuses, priceBuckets, months, budgets, typeOfContract };
}

function mapDispatchToProps(dispatch) {
  const props = {
    onFilterChanged: (queryString, token, tenantId) => {
      dispatch(changeUpcomingPublicationListFilter(queryString, token, tenantId));
    }
  };
  return props;
}

const UpcomingPublicationListFilters = connect(mapStateToProps, mapDispatchToProps)(UpcomingPublicationListFiltersComponent);
export default UpcomingPublicationListFilters;